import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AlertComponent } from "./custom-component/alert/alert.component";
import { SwUpdate } from '@angular/service-worker';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, AlertComponent],
})
export class AppComponent {
    /**
     * Constructor
     */
    constructor(private swUpdate: SwUpdate) {
        if (this.swUpdate.isEnabled) {
            console.log('Service Worker is enabled');

            // Check for updates immediately on load
            this.swUpdate.checkForUpdate();

            // Check for updates every hour
            setInterval(() => {
                this.swUpdate.checkForUpdate();
            }, 60 * 60 * 1000);

            this.swUpdate.versionUpdates.subscribe(event => {
                if (event.type === 'VERSION_READY') {
                    console.log('New version detected. Activating and reloading...');
                    this.swUpdate.activateUpdate().then(() => {
                        // Force a hard reload
                        window.location.reload();
                    });
                }
            });
        }
    }
}
